import React from "react";
import { Person } from "@procore/core-icons";
import { getTextColorForBackground } from "../../gantt/gantt-pure-utils";

interface ResourceBreakdownJobTitlePillProps {
   count: number;
   name: string;
   color: string | null;
}

export function ResourceBreakdownJobTitlePill({
   count,
   name,
   color,
}: ResourceBreakdownJobTitlePillProps) {
   const backgroundColor = color || "#d6d9dc";
   const textColor = getTextColorForBackground(backgroundColor);

   return (
      <div
         style={{
            backgroundColor,
            color: textColor,
            borderRadius: "16px",
            padding: "4px 8px",
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            whiteSpace: "nowrap",
            width: "fit-content",
            minWidth: "auto",
         }}
      >
         <Person size="sm" />
         <span
            style={{
               color: textColor,
               fontFamily: "Inter",
               fontSize: "12px",
               fontWeight: "600",
               lineHeight: "16px",
            }}
         >
            {count}
         </span>
         <span
            style={{
               color: textColor,
               fontFamily: "Inter",
               fontSize: "12px",
               fontWeight: "600",
               lineHeight: "16px",
               letterSpacing: "0.25px",
            }}
         >
            {name}
         </span>
      </div>
   );
}
